import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

// visually hidden styling comes from https://www.a11yproject.com/posts/how-to-hide-content/

const VisuallyHidden = forwardRef(({ style, ...props }, ref) => {
  return (
    <span
      ref={ref}
      style={{
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
        ...style
      }}
      {...props}
    />
  );
});

VisuallyHidden.defaultProps = {
  style: {}
};

VisuallyHidden.propTypes = {
  style: PropTypes.shape({})
};

export default VisuallyHidden;
